import { AspectRatio, Box, Heading, Stack, Text } from "@vinomofo/components";
import { LinkTo, StorefrontImage } from "../../../types";

import { Button } from "../../button";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "../../link";
import styled from "styled-components";

const ImageContainer = styled(Box)`
  &::after {
    content: "";
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 37%,
      rgba(0, 0, 0, 0.75) 92%
    );
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;

export interface ContentTileProps {
  title: string;
  image: StorefrontImage;
  bodyText?: string;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBackgroundColor: string;
    buttonHoverTextColor: string;
    buttonHoverBorderColor: string;
    label: string;
    linkTo: LinkTo;
  };
}

export const ContentTile = ({
  title,
  image,
  primaryCta,
  bodyText,
}: ContentTileProps): JSX.Element => {
  const ctaLink =
    primaryCta?.linkTo?.path ||
    primaryCta?.linkTo?.url ||
    primaryCta?.linkTo?.slug;
  const ctaTarget = primaryCta?.linkTo?.target === "New Tab" ? "_new" : "_self";
  const ctaLabel = primaryCta?.label;

  return (
    <AspectRatio
      ratio={7 / 6}
      borderRadius="4px"
      display="flex"
      alignItems="flex-end"
      justifyContent="center"
      padding={["30px", "40px"]}
    >
      <ImageContainer
        position="absolute"
        top="0"
        right="0"
        bottom="0"
        left="0"
        borderRadius="4px"
        overflow="hidden"
      >
        <GatsbyImage
          image={image}
          style={{ height: "100%", textAlign: "center" }}
          imgStyle={{
            objectFit: "cover",
            objectPosition: "bottom center",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: "100%",
          }}
          alt=""
        />
      </ImageContainer>
      <Box position="relative" textAlign="center">
        <Stack space={[2, 3]}>
          <Heading color="white" variant="xl">
            {title}
          </Heading>
          {bodyText && (
            <Text color="white" variant="sm">
              {bodyText}
            </Text>
          )}
          {ctaLink && ctaLabel && (
            <Box>
              <Button
                as={Box}
                to={ctaLink}
                target={ctaTarget}
                color={primaryCta.buttonTextColor || "white"}
                backgroundColor={primaryCta.buttonColour}
                borderColor={primaryCta.buttonColour}
                hoverBorderColor={primaryCta.buttonHoverBorderColor}
                hoverBackgroundColor={primaryCta.buttonHoverBackgroundColor}
                hoverTextColor={primaryCta.buttonHoverTextColor}
                isCTA
              >
                {ctaLabel}
              </Button>
            </Box>
          )}
        </Stack>
      </Box>
    </AspectRatio>
  );
};
